var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
        container: true,
        absolute: _vm.absolutelyPositioned,
        'one-coin': _vm.iconsTokenAddresses.length === 1,
        'two-coins': _vm.iconsTokenAddresses.length === 2,
        'three-coins': _vm.iconsTokenAddresses.length === 3,
        'four-coins': _vm.iconsTokenAddresses.length === 4,
        'five-coins': _vm.iconsTokenAddresses.length === 5,
    }},[_vm._l((_vm.iconsTokenAddresses),function(tokenAddress){return _c('span',{staticClass:"crypto-icon-fallback"})}),_vm._l((_vm.iconsTokenAddresses),function(tokenAddress){return _c('span',{staticClass:"crypto-icon",style:({'background-image': ("url(" + (_vm.getTokenIcon(tokenAddress)) + ")") })})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }